import styled from "styled-components";

export const IntentWrapper = styled.div`
    width: 50%;
`;
